module.exports = __webpack_public_path__ + "img/43.2616a4c6.jpg";